import React from 'react';
import { Calendar, Clock, Award, Star, CheckCircle, Shield, Users } from 'lucide-react';

const OverviewTab = ({
  service,
  vendor,
  serviceRating,
  serviceReviews,
  formatPrice,
  startingPrice,
}) => {
  return (
    <div className="space-y-8">
      <div className="border-b border-m-border-light pb-6">
        <h3 className="marketing-display-md mb-6 text-m-ink">Service details</h3>
        <div className="space-y-1">
          <div className="flex items-center justify-between border-b border-m-border-light py-3">
            <div className="flex items-center gap-3">
              <Calendar className="h-5 w-5 text-m-ink" />
              <span className="text-sm text-m-ink-muted sm:text-base">Starting price</span>
            </div>
            <span className="text-sm font-medium text-m-ink sm:text-base">
              ${formatPrice(startingPrice)}
            </span>
          </div>
          <div className="flex items-center justify-between border-b border-m-border-light py-3">
            <div className="flex items-center gap-3">
              <Clock className="h-5 w-5 text-m-ink" />
              <span className="text-sm text-m-ink-muted sm:text-base">Duration</span>
            </div>
            <span className="text-sm font-medium text-m-ink sm:text-base">
              {service?.min_duration_hours
                ? `${service.min_duration_hours}-${
                    service.max_duration_hours || service.min_duration_hours
                  } hours`
                : 'Flexible'}
            </span>
          </div>
          <div className="flex items-center justify-between border-b border-m-border-light py-3">
            <div className="flex items-center gap-3">
              <Award className="h-5 w-5 text-m-ink" />
              <span className="text-sm text-m-ink-muted sm:text-base">Pricing type</span>
            </div>
            <span className="text-sm font-medium capitalize text-m-ink sm:text-base">
              {service?.price_type || 'Fixed'}
            </span>
          </div>
          <div className="flex items-center justify-between py-3">
            <div className="flex items-center gap-3">
              <Star className="h-5 w-5 text-m-ink" />
              <span className="text-sm text-m-ink-muted sm:text-base">Service rating</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-m-ink sm:text-base">
                {serviceRating.toFixed(1)}
              </span>
              <div className="flex">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star
                    key={star}
                    className={`h-4 w-4 ${
                      star <= Math.floor(serviceRating)
                        ? 'fill-current text-m-ink'
                        : 'text-m-border-light'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-b border-m-border-light pb-6">
        <h3 className="marketing-display-md mb-6 text-m-ink">Vendor credentials</h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {vendor?.is_verified ? (
            <div className="flex items-center gap-3 rounded-2xl border border-m-border-light bg-m-surface p-4">
              <CheckCircle className="h-5 w-5 shrink-0 text-m-ink" />
              <div>
                <div className="text-sm font-medium text-m-ink">Verified vendor</div>
                <div className="text-xs text-m-ink-muted">Identity confirmed</div>
              </div>
            </div>
          ) : null}
          {vendor?.has_insurance ? (
            <div className="flex items-center gap-3 rounded-2xl border border-m-border-light bg-m-surface p-4">
              <Shield className="h-5 w-5 shrink-0 text-m-ink" />
              <div>
                <div className="text-sm font-medium text-m-ink">Fully insured</div>
                <div className="text-xs text-m-ink-muted">Coverage included</div>
              </div>
            </div>
          ) : null}
          <div className="flex items-center gap-3 rounded-2xl border border-m-border-light bg-m-surface p-4">
            <Users className="h-5 w-5 shrink-0 text-m-ink" />
            <div>
              <div className="text-sm font-medium text-m-ink">{serviceReviews} reviews</div>
              <div className="text-xs text-m-ink-muted">Customer feedback</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
